<footer class="footer pt-5">
    <div class="container">
        <div class="row border-bottom">
            <div class="col-lg-3 text-center">
                <img src="assets/images/logo/logo.png" class="mb-3" alt="" style="width: 192px; height: 150px;">
                <p class="text-center text-white">Seguinos en</p>
                <ul class="d-flex justify-content-center list-unstyled social">
                    <li>
                        <i class="bi-facebook"></i>
                    </li>
                    <li>
                        <i class="bi-instagram"></i>
                    </li>
                    <li>
                        <i class="bi-twitter"></i>
                    </li>
                </ul>
            </div>
            <div class="col-lg-3 mb-4 mb-lg-0">

            </div>
            <div class="col-lg-3 col-6 mb-4 mb-lg-0 ">
                <h4 class="text-white mb-4">Enlaces</h4>
                <ul class="list-unstyled">
                    <li>
                        <a [routerLink]="[rutaLogin]" (click)="openLogin()">Ingreso</a>
                    </li>
                    <li>
                        <a [routerLink]="[rutaRegister]" (click)="openRegister()">Registrarse</a>
                    </li>
                    <li>
                        <a href="tours.php">Destino</a>
                    </li>
                </ul>
            </div>
            <div class="col-lg-3 col-6 mb-4 mb-lg-0">
                <h4 class="text-white mb-4 ">Contacto</h4>
                <ul class="list-unstyled">
                    <li class="d-flex flex-row align-items-center ">
                        <i class="bi bi-geo-alt text-white"></i>
                        <p class="mb-0 ps-3 text-white">Caronti 127</p>
                    </li>
                    <li class="d-flex flex-row align-items-center ">
                        <i class="bi bi-telephone text-white"></i>
                        <p class="mb-0 ps-3 text-white">291-5037575</p>
                    </li>
                    <li class="d-flex flex-row align-items-center ">
                        <i class="bi bi-envelope text-white"></i>
                        <p class="mb-0 ps-3 text-white">bhiviajesturismo@gmail.com</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row pt-3 pb-3 text-center">
            <p class="text-white mb-0">{{year}} Copyright | Creado por Chimpancé</p>
        </div>
    </div>
</footer>
<!-- <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.6.0/dist/umd/popper.min.js" integrity="sha384-KsvD1yqQ1/1+IA7gi3P0tyJcT3vR+NdBTt13hSJ2lnve8agRGXTTyNaBYmCR/Nwi" crossorigin="anonymous"></script> -->
<script src="assets/js/bootstrap.bundle.js"></script>
